// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__1Jnxe","fileBtn":"File_fileBtn__5zwm9","closeBtn":"File_closeBtn__k4rt-","fileSelected":"File_fileSelected__2_ls2","disabled":"File_disabled__22hpJ"};